/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('LocationTemplateEventArticleTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		LocationTemplateEventArticleFactory,
		FindAllLocationTemplateEventArticlesByQueryParamsFactory,
		NoPagingLocationTemplateEventArticleFactory,
		NoPagingLocationFactory,
		NoPagingTemplateEventFactory,
		NoPagingPredefinedArticleTypeFactory,
		NoPagingArticleFactory,
		LocationTemplateEventArticleFindArticleFilteredByArticleFactory
	) {
		$scope.locationTemplateEventArticleList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeLocationTemplateEventArticle)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeLocationTemplateEventArticle);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeLocationTemplateEventArticle = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newLocationTemplateEventArticle', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(locationTemplateEventArticle) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editLocationTemplateEventArticle', {
				locationTemplateEventArticleId: locationTemplateEventArticle.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getLocationTemplateEventArticleList = function() {
			FindAllLocationTemplateEventArticlesByQueryParamsFactory.query(
				{
					locationId: angular.isDefined($scope.locationId) ? $scope.locationId : null,
					templateEventId: angular.isDefined($scope.templateEventId) ? $scope.templateEventId : null,
					predefinedArticleTypeId: angular.isDefined($scope.predefinedArticleTypeId) ? $scope.predefinedArticleTypeId : null,
					articleId: angular.isDefined($scope.articleId) ? $scope.articleId : null,

					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.locationTemplateEventArticleList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getLocationTemplateEventArticleList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedLocationTemplateEventArticleId = id;
			$('#deleteLocationTemplateEventArticleConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			LocationTemplateEventArticleFactory.delete(
				{ id: $scope.selectedLocationTemplateEventArticleId },
				function() {
					$scope.loadAll();
					$('#deleteLocationTemplateEventArticleConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteLocationTemplateEventArticleConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
